import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewContainerRef, ViewChild, OnDestroy, Optional, Inject } from '@angular/core';
import { UploadFile, NzCarouselComponent, ShowUploadListInterface } from 'ng-zorro-antd';
import { UploadConfig } from '../../entities/upload-config';
import { NzMessageService } from 'ng-zorro-antd';
import { Observable, Observer } from 'rxjs';
import { CommonService } from '../../services/common/common.service';
import { URL_CONFIG, UrlConfig } from '../../config/config';

@Component({
  selector: 'app-s-upload',
  templateUrl: './s-upload.component.html',
  styleUrls: ['./s-upload.component.less']
})
export class SUploadComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('carousel') carousel: ViewContainerRef;
  @ViewChild('ca') ca: NzCarouselComponent;
  @Input() fileConfig: UploadConfig;

  @Output() fileUploadSuccess: EventEmitter<any> = new EventEmitter();
  urlConfig: UrlConfig;
  constructor(
    private message: NzMessageService,
    private commonService: CommonService,
    @Optional() @Inject(URL_CONFIG) defaultConfig?: UrlConfig,
  ) {
    this.urlConfig = defaultConfig || {};
  }
  showUploadList = {
    showPreviewIcon: false,
    showRemoveIcon: false,
    hidePreviewIconInNonImage: true,
    showDownloadIcon: false
  };
  uploadFile: any = {};
  previewImage = '';
  previewVisible = false;
  loading = false;
  sliderNumber = 0;
  ngOnInit(): void {
  }

  public get showButton(): boolean  {
    return this.fileConfig.showBtn && this.fileConfig?.fileList?.length < this.fileConfig.max;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initParams();
    this.initIconShowOrHide();

  }

  initIconShowOrHide() {
    this.showUploadList.showRemoveIcon = this.fileConfig.showRemoveIcon;
    this.showUploadList.showDownloadIcon = this.fileConfig.showDownloadIcon;
    this.showUploadList.showPreviewIcon = this.fileConfig.showPreviewIcon;

    this.showUploadList = {
      ...this.showUploadList
    };
  }
  initParams() {
    const fileType = this.fileConfig.fileType;
    this.fileConfig.fileList = this.fileConfig.fileList || [];
    if (fileType === 'img') {
      this.fileConfig.size = this.fileConfig.size || 10 * 1024; // 单张最长不能超过10M
      this.fileConfig.uploadText = this.fileConfig.uploadText || '上传图片';
      // this.fileConfig.max = this.fileConfig.max || 9;  // 最多可上传9张图片，每次只能上传一张
      this.fileConfig.type = 'image/png,image/jpeg,image/jpg';  // 图片格式
      this.fileConfig.acceptType = '.png,.jpeg,.jpg';
    } else if (fileType === 'file') {
      // this.fileConfig.type = 'xlsx';
      // this.fileConfig.acceptType = '.xlsx';
      this.fileConfig.uploadText = this.fileConfig.uploadText || '上传文件';
    }
  }

  handlePreview = (file: UploadFile) => {
    if (!file || file === null) {
      return;
    }
    const dialogObj = {
      type: 'modal',
      title: '图片预览',
      content: this.carousel,
    };
    this.fileConfig.fileList.forEach((f, index) => {
      if (file.url === f.url) {
        this.sliderNumber = index;
      }
    });
    const dialog = this.commonService.createModal(dialogObj);

    dialog.afterOpen.subscribe(_ => {
      this.ca.goTo(this.sliderNumber);
    });
  }

  beforeUpload = (file) => {
    if (!file || file === null) { return; }
    // if (this.fileConfig.fileType === 'img') {
    //   this.uploadFile = file;
    // } else {
    // }
    if (this.fileConfig.fileType === 'img') {
      return new Observable((observer: Observer<boolean>) => {
        const isLtMax = file.size / 1024 <= this.fileConfig.size;
        if (!isLtMax) {
          this.message.error(`图片不能超过${this.fileConfig.size / 1024}M`);
          observer.complete();
          return;
        }
        // 当不写nzAccept属性时，需要校验文件格式，则需要下面这段代码
        // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        // if (!isJpgOrPng) {
        //   this.message.error('不支持该图片格式');
        //   observer.complete();
        //   return;
        // }
        // observer.next(isLtMax && isJpgOrPng);
        observer.next(isLtMax);
        observer.complete();
      });
    } else {
      // this.uploadFile = file;
    }
  }

  handleChange(info: { file: UploadFile }) {
    if (!info || !info.file) {
      this.message.error('上传失败');
      return;
    }
    this.handleChangeFile(info);
  }

  handleChangeFile(info) {
    if (!info || info === null) {
      return;
    }

    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        this.fileConfig.showBtn = false;
        break;
      case 'done':
        this.loading = false;
        this.fileUploadSuccess.emit(info.file);
        if (this.fileConfig.fileType === 'img') {
          this.getBase64(info.file.originFileObj, (img: string) => {
            info.file.url = img;
            this.fileConfig.fileList[this.fileConfig.fileList.length - 1].url = img;
            this.fileConfig.fileList[this.fileConfig.fileList.length - 1].fileId = info.file.response.data;
            this.fileConfig.fileList[this.fileConfig.fileList.length - 1].fileName = info.file.name;
            this.fileConfig.fileList[this.fileConfig.fileList.length - 1].fileExtension = this.extname(info.file.name);
          });
        } else if (this.fileConfig.fileType === 'file') {
          if (info.type === 'success') {
            if (this.urlConfig?.downloadUrl) {
              this.fileConfig.fileList[this.fileConfig.fileList.length - 1].url = this.urlConfig.downloadUrl + '/' + info.file.response.data;
            }
            this.fileConfig.fileList[this.fileConfig.fileList.length - 1].fileId = info.file.response.data;
            this.fileConfig.fileList[this.fileConfig.fileList.length - 1].fileName = info.file.name;
            this.fileConfig.fileList[this.fileConfig.fileList.length - 1].fileExtension = this.extname(info.file.name);
          }
        }

        this.fileConfig.showBtn = !(this.fileConfig.fileList.length === this.fileConfig.max);
        break;
      case 'error':
        this.message.error('Network error');
        this.loading = false;
        break;
    }
  }

  /**
   * 删除文件
   */
  removeFile = (file) => {
    this.fileConfig.fileList.forEach((a, index) => {
      if (a.fileId === file.fileId) {
        this.fileConfig.fileList.splice(index, 1);
      }
    });
    if (this.fileConfig.fileList.length < this.fileConfig.max) {
      this.fileConfig.showBtn = true;
    }
  }

  getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  extname(fileName) {
    if (!fileName || typeof fileName !== 'string') {
      return false;
    }
    const a = fileName.split('').reverse().join('');
    const b = a.substring(0, a.search(/\./)).split('').reverse().join('');
    return `.${b}`;
  }
  prev() {
    this.ca.pre();
  }
  next() {
    this.ca.next();
  }
  ngOnDestroy(): void {
    this.fileConfig.fileList = [];
  }
}
